module.exports = __webpack_public_path__ + "img/arrow_left_black.77732106.svg";